import LightTheme from './light'
import DarkTheme from './dark'
import ExtraDarkTheme from './extradark'
import GreenTheme from './green'
import SpotifyTheme from './spotify'
import LigeraTheme from './ligera'
import MonokaiTheme from './monokai'
import ElectricPurpleTheme from './electricPurple'
import NordTheme from './nord'
import GruvboxDarkTheme from './gruvboxDark'
import CatppuccinMacchiatoTheme from './catppuccinMacchiato'
import DraculaTheme from './dracula'
import NuclearTheme from './nuclear'
import NutballTheme from './nutball'
import AmusicTheme from './amusic'
import SquiddiesGlassTheme from './SquiddiesGlass'
import NautilineTheme from './nautiline'

export default {
  // Classic default themes
  LightTheme,
  DarkTheme,

  // New themes should be added here, in alphabetic order
  AmusicTheme,
  CatppuccinMacchiatoTheme,
  DraculaTheme,
  ElectricPurpleTheme,
  ExtraDarkTheme,
  GreenTheme,
  GruvboxDarkTheme,
  LigeraTheme,
  MonokaiTheme,
  NautilineTheme,
  NordTheme,
  NuclearTheme,
  NutballTheme,
  SpotifyTheme,
  SquiddiesGlassTheme,
}
